
import { Component, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "app/base-module/base-service/auth.service";
import { BaseComponent } from "../../base-module/base-component/base.component";
import { FiltrarUsuariosComponent } from "../filtrar-usuarios/filtrar-usuarios.component";
import { UsuariosService } from "../services/usuarios.service";
import { UsuariosCadastrarComponent } from "../usuarios-cadastrar/usuarios-cadastrar.component";
import { UsuariosListaTabelaComponent } from "./tabela/usuarios-lista-tabela.component";

@Component({
    selector: "app-usuarios-lista",
    templateUrl: "./usuarios-lista.component.html",
    styleUrls: ["./usuarios-lista.component.scss"]
})
export class UsuariosListaComponent extends BaseComponent {

    loadingLocal: any;
    override loadingIndicator: boolean = false;
    data: any = {};
    public search = new FormControl();

    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;
    @ViewChild(UsuariosListaTabelaComponent) table!: UsuariosListaTabelaComponent;

    constructor(public service: UsuariosService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public loading: MatDialog,
        public _authService: AuthService,
        public _route: Router,
        private _Activatedroute: ActivatedRoute) {
        super(dialog, snackBar);

        this.data = this._Activatedroute.snapshot.data["type"];

        if (this.data == "logout") {
            this.logout();
        }

        this.params.search = "";
    }

    openCadastro(): void {
        const dialogRef = this.dialog.open(UsuariosCadastrarComponent, {
            panelClass: "contact-form-dialog",
            width: "400px",
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel") {
                this.showSuccess("Usuário cadastrado com sucesso!");
                this.table.getAll();
            } else if (result != undefined && result != "cancel") {
                this.showError("Ocorreu um erro ao tentar cadastrar um novo usuário.");
            }
        });
    }


    openFiltro(): void {
        const dialogRef = this.dialog.open(FiltrarUsuariosComponent, {
            width: "700px",
            data: this.params
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != "cancel" && result != undefined) {
                this.table.applyFilters(result);
            }
        });
    }

    onEnter(value: string = '') {
        this.table.stopNow();
        this.params.search = value;
        this.search.setValue(value);
        this.table.getAll();
    }

    logout() {
        this._authService.logout();
        this._route.navigate(["/auth/login"]);
    }
}
